import { StyledRoot } from './styled';
export function Root(props) {
    const { defaultOpenSectionsIds, children } = props;
    return (<StyledRoot multiple defaultValue={defaultOpenSectionsIds}>
      {children}
    </StyledRoot>);
}
